
import Vue from 'vue'
import Component from 'vue-class-component'
import { Model, Prop } from 'vue-property-decorator'

@Component({
  name: 'sheet',
  components: {},
})
export default class IndexView extends Vue {
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String, default: '' }) left!: string
  @Prop({ type: Function, default: null }) cancel!: () => void
  @Prop({ type: Function, default: null }) leftAction!: () => void
  @Prop({ type: String, default: '' }) right!: string
  @Prop({ type: Function, default: null }) rightAction!: () => void
  @Prop({ type: Boolean, default: false }) showCalcel!: boolean
  @Prop({ type: Boolean, default: true }) clickOverlay!: boolean
  @Model('change') show!: boolean

  get showActionSheet() {
    return this.show
  }

  set showActionSheet(val) {
    // this.handleClick()
  }

  handleLeft() {
    this.leftAction && this.leftAction()
    this.handleClose()
  }

  handleRight() {
    this.rightAction && this.rightAction()
    this.handleClose()
  }

  handleClose() {
    this.$emit('change', false)
  }

  handleOverlay() {
    console.log('关闭')
    if (!this.clickOverlay) return
    this.cancel && this.cancel()
    this.handleClose()
  }
}
